import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import {switchMap, catchError, mergeMap, withLatestFrom, map} from 'rxjs/operators';
import * as complaintActions from '../actions/complaint';
import { RestService } from '../../service/rest.service';
import { ServerDTO } from '../../models/app.model';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers';
import { toPayload } from './BaseEffects';
import { Complaint } from '../../models/reception.model';



@Injectable()
export class ComplaintEffects {

  constructor(
    private actions$: Actions,
    private restService: RestService,
    protected store: Store<fromRoot.AppState>
  ) {}

  @Effect()
  loadComplaints$ = this.actions$.pipe(
    ofType<complaintActions.LoadAll>(complaintActions.LOAD_ALL),
    withLatestFrom(this.store, (action, state) => state.complaints.selectedYear),
    switchMap((year) => {
      return this.restService.getAllDocuments('reception/complaints', year ? year : new Date().getFullYear().toString())
        .pipe(
          mergeMap(data => [
            new complaintActions.LoadSuccess(data as ServerDTO)
          ]),
          catchError(error => [
            new complaintActions.LoadFail(error),
          ])
        );
    })
  );

  @Effect()
  loadOneComplaint$ = this.actions$.pipe(
    ofType<complaintActions.LoadOne>(complaintActions.LOAD_ONE),
    map(toPayload),
    switchMap((id) => {
      return this.restService.getOneDocument(id, 'reception/complaints')
        .pipe(
          mergeMap(data => [
            new complaintActions.LoadOneSuccess(data as Complaint)
          ]),
          catchError(error => [
            new complaintActions.LoadOneFail(error),
          ])
        );
    })
  );

}
